module.exports = __webpack_public_path__ + "img/razzo.9a7c4303.webp";